var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"base-button tw-font-[400] tw-border",class:[_vm.sizeClass, _vm.colorClass, _vm.disabledClass]},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }